import React from 'react';
import NoticeProductDetailInfo from '../NoticeProductDetailInfo';
import NoticeProductDetailItemInfo from '../NoticeProductDetailItemInfo';

const NoticeProductDetailWrap = (props) => {
  const { noticeProductDetail, isEditable, form, setData, getList, getProductSubCategoryList } = props;

  return (
    <div className="notice-product-detail-wrap">
      {/*상품 공지사항 기본 정보*/}
      <NoticeProductDetailInfo info={noticeProductDetail.info} isEditable={isEditable} form={form} setData={setData} />

      {/*상품 공지사항 상품 정보*/}
      <NoticeProductDetailItemInfo
        itemListInfo={noticeProductDetail.itemListInfo}
        isEditable={isEditable}
        getProductSubCategoryList={getProductSubCategoryList}
        getList={getList}
      />
    </div>
  );
};

export default NoticeProductDetailWrap;
